// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Y3-z","displaySixCardTiles":"Z3-z"};